// import * as React from 'react';
// import { FormColumnConfig, MasterConfigs } from '../../../../../../../interfaces/entity';
// import DrawerComponent from '../../../../../../../components/Forms/Drawer';
// import { Col, Divider, Form, message, Modal, Row, Typography } from 'antd';
// import RenderFormItem from '../../../../../../../components/Forms/FormItems';
// import { getData } from '../../../../../../../actions/apiCall';
// import { useDispatch } from 'react-redux';
// import { useSelector } from 'react-redux';
// import { postData } from '../../../../../../../actions/developer';
// const { useForm } = Form;
// import dayjs from 'dayjs';
// import FeedbackHistory from './Feedbackhistory';
// const { Title } = Typography;

// const FeedbackForm = ({ isVisible, onClose, id, level, data }) => {
//     const [visible, setVisible] = React.useState(isVisible);
//     const [loading, setLoading] = React.useState(false);
//     const [isView, setView] = React.useState(false);
//     const [skillsForm, setSkillsForm] = React.useState([]);
//     const [selectedURL, setSelectedURL] = React.useState(null)
//     const [roundtype, setRoundType] = React.useState('');
//     const [form] = useForm();
//     const dispatch = useDispatch();
//     const user: any = useSelector((app: any) => app?.app?.user);
//     const feedbackData = [
//         "Not good in communication",
//         "Not good in coding",
//         "Not good in presentation",
//         "Not good in confidence",
//         "Not good in technical skills",
//         "Not good in personal ability",
//         "Not good in managerial skills",
//         "Not good in HR skills",
//         "Did not attend the interview",
//         "Did not accept the offer",
//         "Lack of problem-solving skills",
//         "Poor logical reasoning",
//         "Insufficient domain knowledge",
//         "Lack of adaptability",
//         "Not a cultural fit",
//         "Did not meet experience requirements",
//         "Salary expectations too high",
//         "Failed background verification",
//         "Negative attitude",
//         "Unprofessional behavior",
//         "Late for the interview",
//         "Did not follow instructions",
//         "Failed technical assessment",
//         "Poor team collaboration skills",
//         "Lack of enthusiasm for the role",
//         "Did not provide satisfactory references",
//         "Poor time management skills",
//         "Did not demonstrate leadership qualities",
//         "Lack of negotiation skills",
//         "Overqualified for the role",
//         "Job role mismatch",
//         "Declined due to personal reasons",
//         "Joined another company",
//         "Visa or work permit issues",
//         "Failed psychometric or aptitude test",
//         "Did not respond to follow-ups",
//         "Failed to justify resume claims",
//         "Misrepresentation of skills or experience",
//         "Rejected due to company restructuring",
//         "Did not fit long-term company vision",
//         "Low energy levels during the interview"
//     ]

//     const roundType = [
//         'Coding',
//         'Technical',
//         'HR',
//         'Managerial',
//         'Salary Discussion',
//     ]

//     React.useEffect(() => {
//         setVisible(isVisible)
//     }, [isVisible])

//     React.useEffect(() => {
//         if (isVisible) {
//             loadFeedback()
//         }
//     }, [isVisible])

//     React.useEffect(() => {
//         if (isVisible) {
//             onViewModal(data)
//         }
//     }, [data, isVisible])


//     let config: MasterConfigs = {
//         api: () => '/feedback/',
//         modalTitle: (text) => `${text} feedback`,
//         modalProps: { width: 900 },
//         drawerProps: { width: '100%' },
//         getFormColumns: () => {
//             return [
//                 {
//                     label: 'First Name',
//                     name: 'firstName',
//                     type: 'text',
//                     inputProps: { disabled: true }
//                 },
//                 {
//                     label: 'Middle Name',
//                     name: 'middleName',
//                     type: 'text',
//                     inputProps: { disabled: true }
//                 },
//                 {
//                     label: 'Last Name',
//                     name: 'lastName',
//                     type: 'text',
//                     inputProps: { disabled: true }
//                 },
//                 {
//                     label: 'Date',
//                     name: 'date',
//                     type: 'date',
//                     rules: [{
//                         required: true,
//                         message: 'Field is required'
//                     }],
//                 },
//                 {
//                     label: 'Job Role',
//                     name: 'profileFor',
//                     selectProps: { disabled: true },
//                     type: 'select',
//                     isCombo: true,
//                     filterFiled: true
//                 },
//                 {
//                     label: 'Interviewer',
//                     name: 'interviewer',
//                     type: 'text',
//                     rules: [{
//                         required: true,
//                         message: 'Field is required'
//                     }],
//                 },
//                 {
//                     label: 'Round Type',
//                     name: 'roundType',
//                     type: 'select',
//                     children: roundType.map(ele => ({
//                         value: ele,
//                         name: ele
//                     })),
//                     selectProps: { onChange: (text) => setRoundType(text), allowClear: true },
//                 },
//                 roundtype == 'Technical' && {
//                     label: 'Technical Skills',
//                     type: 'divider',
//                     span: 24,
//                     dividerProps: {
//                         type: 'horizontal',
//                         orientation: 'left'
//                     }
//                 },
//                 roundtype == 'Technical' && {
//                     label: 'Skills',
//                     name: 'skills',
//                     type: 'form',
//                     span: 24,
//                     form: skillsForm
//                 },
//                 {
//                     label: 'Personal Ability Skills',
//                     type: 'divider',
//                     span: 24,
//                     dividerProps: {
//                         type: 'horizontal',
//                         orientation: 'left'
//                     }
//                 },
//                 {
//                     label: 'Personal Ability',
//                     name: 'personalAbility',
//                     type: 'form',
//                     span: 24,
//                     form: ['Communication', 'Confidence', 'Presentation'].map((ele): FormColumnConfig => ({
//                         label: ele,
//                         name: ele,
//                         type: 'rate',
//                         span: 8,
//                         rules: [{
//                             required: true,
//                             message: 'Field is required'
//                         }],
//                         rateProps: {
//                             count: 10
//                         }
//                     })),
//                 },
//                 {
//                     label: 'Approval Status',
//                     type: 'divider',
//                     span: 24,
//                     dividerProps: {
//                         type: 'horizontal',
//                         orientation: 'left'
//                     }
//                 },
//                 {
//                     label: 'Approval Status',
//                     name: 'approvalStatus',
//                     type: 'select',
//                     rules: [{
//                         required: true,
//                         message: 'Field is required'
//                     }],
//                     children: [
//                         {
//                             value: 'Selected',
//                             name: 'Selected'
//                         },
//                         {
//                             value: 'Rejected',
//                             name: 'Rejected'
//                         },
//                         {
//                             value: 'Hold',
//                             name: 'Hold'
//                         }
//                     ]
//                 },
//                 {
//                     label: 'Feedback',
//                     name: 'feedback',
//                     type: 'select',
//                     children: feedbackData.map(ele => ({
//                         value: ele,
//                         name: ele
//                     })),
//                     selectProps: { allowClear: true, mode: 'tags' }
//                 },
//                 {
//                     name: 'comments',
//                     label: 'Comment',
//                     type: 'textarea',
//                     span: 24,
//                     inputTextAreaProps: { rows: 2 }
//                 },
//                 {
//                     label: 'Video/Screenshorts',
//                     name: 'vedioScreenshorts',
//                     type: 'file',
//                     uploadProps: { multiple: true, accept: 'image/*', listType: 'picture-card' }
//                 }
//             ] as FormColumnConfig[]
//         },
//         combo: [
//             {
//                 name: 'profileFor',
//                 api: '/role',
//                 idKey: '_id',
//                 render: (text) => text.name
//             },
//             {
//                 name: 'appliedFor',
//                 api: '/vendor/crm/current_opening',
//                 idKey: '_id',
//                 render: (text) => {
//                     return `AGJ${text.jobId}_${text.jobTitle?.name}_${text.workLocation}_${text.experiance}+Years`;
//                 },
//             },
//         ],
//     }

//     const getRate = (ele) => {
//         return {
//             label: ele,
//             name: ele,
//             span: 8,
//             type: 'rate',
//             rules: [{
//                 required: true,
//                 message: 'Field is required'
//             }],
//             rateProps: {
//                 count: 10
//             }
//         }
//     }

//     const loadFeedback = async () => {
//         const resData = await dispatch(getData(`${config.api()}get/${level}/${id}/${user.email}`))
//         if (resData.code == 200) {
//             const { firstName, lastName, middleName, appliedFor, feedback, addedData } = resData.data;
//             const { skils, jobTitle } = addedData
//             setSkillsForm(skils?.map(_form => getRate(_form)))
//             if (feedback?.approvalStatus) {
//                 setView(true)
//             }
//             form.setFieldsValue({
//                 firstName,
//                 lastName,
//                 middleName,
//                 profileFor: jobTitle,
//                 personalAbility: feedback?.personalAbility ?? [{}],
//                 skills: feedback?.skills ?? [{}],
//                 interviewer: user.email,
//                 approvalStatus: feedback?.approvalStatus,
//                 comments: feedback?.comments,
//                 date: dayjs(feedback?.date)
//             })
//         }
//     }

//     const onCancel = () => {
//         form.resetFields();
//         onClose()
//         setLoading(false)
//     }

//     const onSubmit = async (values) => {
//         setLoading(true)
//         const resData = await dispatch(postData(config.api(), { ...values, developer: id, date: dayjs(values.date), level }))
//         if (resData) {
//             onRefresh();
//             onCancel();
//             message.success('Successfully submited feedback')
//         } else {
//             setLoading(false)
//             message.error('Failed to update')
//         }
//     }

//     const onRefresh = () => {
//         dispatch({
//             type: 'REFRESH_TABLE',
//             refreshTable: true
//         })
//     }

//     const onViewModal = (item) => {
//         const url = `${process.env.FILE_URL}${item?.resume}`
//         setSelectedURL({ ...item, name: item?.firstName, url, skills: item?.skills });
//     }

//     const renderNestedForm = (nestedFields, combo) => (
//         <Form.List name={nestedFields.name}>
//             {(fields, { add, remove }) => (
//                 <>
//                     {fields.map(({ key, name, ...restField }) => (
//                         <Row gutter={[16, 16]}>
//                             <Col span={24} >
//                                 <div >
//                                     <Row gutter={[16, 16]} key={key}>
//                                         {nestedFields.form.map((field) => (
//                                             <Col span={field.span ?? 12} key={field.name}>
//                                                 <RenderFormItem column={{ ...field, name: [name, field.name], ...restField }} combo={combo} form={form} />
//                                             </Col>
//                                         ))}
//                                     </Row>
//                                 </div>
//                             </Col>
//                         </Row>
//                     ))}
//                 </>
//             )}
//         </Form.List>
//     );

//     return <Modal
//         onCancel={onCancel}
//         loading={loading}
//         maskClosable={config.maskClosable}
//         title={config?.modalTitle ? config?.modalTitle('Add') : 'Add'}
//         onOk={() => { form.submit() }}
//         open={visible}
//         width={1200}
//     >
//         <div className='w-full'>
//             <Form
//                 layout='vertical'
//                 form={form}
//                 onFinish={onSubmit}
//             >
//                 <Row gutter={[16, 16]} className='w-full'>
//                     <Col span={24}>
//                         <Row gutter={[16, 16]}>
//                             {config.getFormColumns().map((column) => (
//                                 <Col span={column.span ?? 8}>
//                                     {column.type !== 'form' ? <React.Fragment key={column.name}>
//                                         <RenderFormItem column={column} combo={config.combo} form={form} />
//                                     </React.Fragment> :
//                                         <React.Fragment key={column.name}>
//                                             {renderNestedForm(column, config.combo)}
//                                         </React.Fragment>
//                                     }
//                                 </Col>
//                             ))}
//                         </Row>
//                     </Col>
//                 </Row>
//             </Form>
//         </div>
//     </Modal>
// };

// export default FeedbackForm;



// FeedbackForm.tsx
import * as React from 'react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, message, Modal, Row, Typography } from 'antd';

import { FormColumnConfig, MasterConfigs } from '../../../../../../../interfaces/entity';
import DrawerComponent from '../../../../../../../components/Forms/Drawer';
import RenderFormItem from '../../../../../../../components/Forms/FormItems';
import FeedbackHistory from './Feedbackhistory';
import { getData } from '../../../../../../../actions/apiCall';
import { postData } from '../../../../../../../actions/developer';

const { useForm } = Form;
const { Title } = Typography;

const FeedbackForm = ({ isVisible, onClose, id, level, data }) => {
    const [visible, setVisible] = React.useState(isVisible);
    const [loading, setLoading] = React.useState(false);
    const [isView, setView] = React.useState(false);
    const [skillsForm, setSkillsForm] = React.useState([]);
    const [selectedURL, setSelectedURL] = React.useState(null);
    const [roundtype, setRoundType] = React.useState('');

    const [form] = useForm();
    const dispatch = useDispatch();
    const user = useSelector((app: any) => app?.app?.user);

    const feedbackReasons = [
        "Not good in communication",
        "Not good in coding",
        "Not good in presentation",
        "Did not attend the interview",
        "Lack of problem-solving skills",
        "Poor logical reasoning",
        "Insufficient domain knowledge",
        "Not a cultural fit",
        "Failed technical assessment",
        "Job role mismatch",
        "Low energy levels during the interview"
    ];

    const roundTypes = [
        'Coding',
        'Technical',
        'HR',
        'Managerial',
        'Salary Discussion'
    ];

    const getRateField = (label) => ({
        label,
        name: label,
        type: 'rate',
        span: 8,
        rules: [{ required: true, message: 'Required' }],
        rateProps: { count: 10 }
    });

    const config: MasterConfigs = {
        api: () => '/feedback/',
        modalTitle: (text) => `${text} Feedback`,
        modalProps: { width: 900 },
        drawerProps: { width: '100%' },
        getFormColumns: () => {
            const commonFields: FormColumnConfig[] = [
                { label: 'First Name', name: 'firstName', type: 'text', inputProps: { disabled: true } },
                { label: 'Middle Name', name: 'middleName', type: 'text', inputProps: { disabled: true } },
                { label: 'Last Name', name: 'lastName', type: 'text', inputProps: { disabled: true } },
                { label: 'Date', name: 'date', type: 'date', rules: [{ required: true, message: 'Required' }] },
                { label: 'Job Role', name: 'profileFor', type: 'select', isCombo: true, filterFiled: true, selectProps: { disabled: true } },
                { label: 'Interviewer', name: 'interviewer', type: 'text', rules: [{ required: true, message: 'Required' }] },
                {
                    label: 'Round Type',
                    name: 'roundType',
                    type: 'select',
                    children: roundTypes.map(type => ({ value: type, name: type })),
                    selectProps: {
                        onChange: (value) => setRoundType(value),
                        allowClear: true
                    }
                }
            ];

            const technicalFields = roundtype === 'Technical' ? [
                { label: 'Technical Skills', type: 'divider', span: 24 },
                { label: 'Skills', name: 'skills', type: 'form', span: 24, form: skillsForm }
            ] : [];



            const additionalFields: FormColumnConfig[] = [
                { label: 'Personal Ability Skills', type: 'divider', span: 24 },
                {
                    label: 'Personal Ability',
                    name: 'personalAbility',
                    type: 'form',
                    span: 24,
                    form: ['Communication', 'Confidence', 'Presentation'].map(getRateField) as FormColumnConfig[]
                },
                { label: 'Approval Status', type: 'divider', span: 24 },
                {
                    label: 'Approval Status',
                    name: 'approvalStatus',
                    type: 'select',
                    rules: [{ required: true, message: 'Required' }],
                    children: ['Selected', 'Rejected', 'Hold'].map(status => ({ value: status, name: status }))
                },
                {
                    label: 'Feedback',
                    name: 'feedback',
                    type: 'select',
                    children: feedbackReasons.map(reason => ({ value: reason, name: reason })),
                    selectProps: { allowClear: true, mode: 'tags' }
                },
                { name: 'comments', label: 'Comment', type: 'textarea', span: 24, inputTextAreaProps: { rows: 2 } },
                { label: 'Video/Screenshots', name: 'vedioScreenshorts', type: 'file', uploadProps: { multiple: true, accept: 'image/*', listType: 'picture-card' } }
            ];

            return [...commonFields, ...technicalFields, ...additionalFields] as FormColumnConfig[];
        },
        combo: [
            { name: 'profileFor', api: '/role', idKey: '_id', render: (t) => t.name },
            {
                name: 'appliedFor',
                api: '/vendor/crm/current_opening',
                idKey: '_id',
                render: (text) => `AGJ${text.jobId}_${text.jobTitle?.name}_${text.workLocation}_${text.experiance}+Years`
            }
        ]
    };

    const loadFeedback = async () => {
        const resData = await dispatch(getData(`${config.api()}get/${level}/${id}/${user.email}`));
        if (resData.code === 200) {
            const { firstName, lastName, middleName, appliedFor, feedback, addedData } = resData.data;
            const { skils, jobTitle } = addedData;

            setSkillsForm(skils?.map(getRateField));
            if (feedback?.approvalStatus) setView(true);

            form.setFieldsValue({
                firstName,
                lastName,
                middleName,
                profileFor: jobTitle,
                personalAbility: feedback?.personalAbility ?? [{}],
                skills: feedback?.skills ?? [{}],
                interviewer: user.email,
                approvalStatus: feedback?.approvalStatus,
                comments: feedback?.comments,
                date: dayjs(feedback?.date)
            });
        }
    };

    const onSubmit = async (values) => {
        setLoading(true);
        const payload = { ...values, developer: id, date: dayjs(values.date), level };
        const resData = await dispatch(postData(config.api(), payload));

        if (resData) {
            dispatch({ type: 'REFRESH_TABLE', refreshTable: true });
            message.success('Successfully submitted feedback');
            form.resetFields();
            onClose();
        } else {
            message.error('Failed to update');
        }
        setLoading(false);
    };

    React.useEffect(() => { setVisible(isVisible); }, [isVisible]);
    React.useEffect(() => { if (isVisible) loadFeedback(); }, [isVisible]);
    React.useEffect(() => { if (isVisible) setSelectedURL({ ...data, name: data?.firstName, url: `${process.env.FILE_URL}${data?.resume}` }); }, [data, isVisible]);

    const renderNestedForm = (nestedFields, combo) => (
        <Form.List name={nestedFields.name}>
            {(fields) => fields.map(({ key, name, ...restField }) => (
                <Row gutter={[16, 16]} key={key}>
                    {nestedFields.form.map((field) => (
                        <Col span={field.span ?? 12} key={field.name}>
                            <RenderFormItem column={{ ...field, name: [name, field.name], ...restField }} combo={combo} form={form} />
                        </Col>
                    ))}
                </Row>
            ))}
        </Form.List>
    );

    return (
        <Modal
            title={config.modalTitle('Add')}
            open={visible}
            onCancel={() => { form.resetFields(); onClose(); setLoading(false); }}
            onOk={() => form.submit()}
            confirmLoading={loading}
            width={1200}
            maskClosable={false}
        >
            <Form layout='vertical' form={form} onFinish={onSubmit}>
                <Row gutter={[16, 16]}>
                    {config.getFormColumns().map((column) => (
                        <Col span={column.span ?? 8} key={column.name}>
                            {column.type !== 'form'
                                ? <RenderFormItem column={column} combo={config.combo} form={form} />
                                : renderNestedForm(column, config.combo)}
                        </Col>
                    ))}
                </Row>
            </Form>
        </Modal>
    );
};

export default FeedbackForm;